var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { api } from './baseApi';
export var restaurantsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getRestaurants: builder.query({
                query: function (_a) {
                    var cityId = _a.cityId, type = _a.type;
                    return ({
                        url: "/restaurants/all",
                        method: 'GET',
                        params: __assign(__assign({}, (cityId != null ? { cityId: cityId } : {})), (type && String(type).trim() !== '' ? { type: String(type).trim() } : {})),
                    });
                },
                providesTags: ['Restaurants'],
            }),
            getRestaurantsWithSearch: builder.query({
                query: function (_a) {
                    var page = _a.page, limit = _a.limit, search = _a.search, ownerId = _a.ownerId, userRestId = _a.userRestId, managedRestIds = _a.managedRestIds, role = _a.role, type = _a.type, cityId = _a.cityId;
                    return ({
                        url: "/restaurants/searchWithPagination",
                        method: 'GET',
                        params: { page: page, limit: limit, search: search, ownerId: ownerId, userRestId: userRestId, managedRestIds: managedRestIds, role: role, type: type, cityId: cityId },
                    });
                },
                providesTags: ['Restaurants'],
            }),
            createRestaurants: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: "/restaurants",
                        body: body,
                    });
                },
                invalidatesTags: ['Restaurants'],
            }),
            editRestaurants: builder.mutation({
                query: function (_a) {
                    var body = _a.body, id = _a.id;
                    return ({
                        method: 'PATCH',
                        url: "/restaurants/".concat(id),
                        body: body,
                    });
                },
                invalidatesTags: ['Restaurants', 'RestNetwork'],
            }),
            /** Только смена сети — инвалидирует списки сетей и ресторанов в сети */
            assignRestaurantToNetwork: builder.mutation({
                query: function (_a) {
                    var restaurantId = _a.restaurantId, networkId = _a.networkId;
                    return ({
                        method: 'PATCH',
                        url: "/restaurants/".concat(restaurantId),
                        body: { networkId: networkId },
                    });
                },
                invalidatesTags: ['Restaurants', 'RestNetwork'],
            }),
            deleteRestaurants: builder.mutation({
                query: function (_a) {
                    var restaurantsId = _a.restaurantsId;
                    return ({
                        method: 'DELETE',
                        url: "/restaurants/delete/".concat(restaurantsId),
                    });
                },
                invalidatesTags: ['Restaurants'],
            }),
            getRestaurantById: builder.query({
                query: function (id) {
                    return ({
                        url: "/restaurants/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: ['Restaurants'],
            }),
            uploadRestaurantCoverPhoto: builder.mutation({
                query: function (_a) {
                    var id = _a.id, file = _a.file;
                    var body = new FormData();
                    body.append('file', file);
                    return {
                        url: "/restaurants/".concat(id, "/cover-photo"),
                        method: 'POST',
                        body: body,
                    };
                },
                invalidatesTags: ['Restaurants'],
            }),
        });
    },
});
export var useGetRestaurantByIdQuery = restaurantsApi.useGetRestaurantByIdQuery, useCreateRestaurantsMutation = restaurantsApi.useCreateRestaurantsMutation, useGetRestaurantsWithSearchQuery = restaurantsApi.useGetRestaurantsWithSearchQuery, useDeleteRestaurantsMutation = restaurantsApi.useDeleteRestaurantsMutation, useEditRestaurantsMutation = restaurantsApi.useEditRestaurantsMutation, useAssignRestaurantToNetworkMutation = restaurantsApi.useAssignRestaurantToNetworkMutation, useGetRestaurantsQuery = restaurantsApi.useGetRestaurantsQuery, useUploadRestaurantCoverPhotoMutation = restaurantsApi.useUploadRestaurantCoverPhotoMutation;
